import compact from "lodash/compact";
import max from "lodash/max";
import some from "lodash/some";
import { CurrentAccount } from "PFCore/types";

import { ACTIVITY_ENTITIES, DEFAULT_MIN_TERM_LENGTH } from "./search_autocomplete.consts";
import { SearchConfig, SearchEntity } from "./search_autocomplete.types";

export const getTermMinLength = (
  config: SearchConfig,
  minimumSearchTermLength: CurrentAccount["config"]["minimum_search_term_length"]
) => {
  const isProfileInConfig = some(config, ({ entity }) => entity === SearchEntity.Profile);
  const isActivityInConfig = some(config, ({ entity }) => ACTIVITY_ENTITIES.includes(entity));

  return (
    max(
      compact([
        isProfileInConfig && minimumSearchTermLength.profiles,
        isActivityInConfig && minimumSearchTermLength.activities
      ])
    ) ?? DEFAULT_MIN_TERM_LENGTH
  );
};
